import { tokenStorage } from "../services/authService";

interface JwtPayload {
  exp?: number;
}

export const isTokenValid = (token: string | null): boolean => {
  if (!token) {
    console.log("No token");
    return false;
  }

  try {
    const payloadBase64 = token.split(".")[1];
    if (!payloadBase64) {
      console.log("token invalid");
      return false;
    }

    const payloadJson = atob(
      payloadBase64.replace(/-/g, "+").replace(/_/g, "/")
    );
    const payload: JwtPayload = JSON.parse(payloadJson);

    const isValid = payload.exp ? payload.exp * 1000 > Date.now() : false;
    return isValid;
  } catch (error) {
    console.log("isTokenValid - parsing error:", error);
    return false;
  }
};

export function truncateString(str: string, maxLength: number) {
  if (str.length > maxLength) {
    return str.substring(0, maxLength) + "...";
  }
  return str;
}

export const downloadFile = async (path: string, filename: string) => {
  
  if (path.includes('amazonaws.com') || path.includes('X-Amz-Signature')) {
    const a = document.createElement('a');
    a.href = path;
    a.target = '_blank';
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return;
  }

  const access_token = tokenStorage.getAccessToken();
  try {
    const response = await fetch(path, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Error downloading file");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();

    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading", error);
  }
};


export const openInNewTab_2 = async (path: string) => {
  if (path.includes('X-Amz-Signature') || path.includes('amazonaws.com')) {
    window.open(path, '_blank');
    return;
  }

  const access_token = tokenStorage.getAccessToken();
  try {
    const response = await fetch(path, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');
  } catch (error) {
    console.error('Failed to open PDF:', error);
  }
};

export const capitalizeFirstLetter = (str: string): string => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const fileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
